// extracted by mini-css-extract-plugin
export default {"root":"Rule_root__w7nIk"};